module.exports = __webpack_public_path__ + "img/mobile/General/spelser@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/General/spelser@2x.png
// module id = 191
// module chunks = 0